import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Box } from "lucide-react";
import "@/App.css";
import OrderSection from "../components/landing/OrderSection";

export default function OrderPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="site-shell order-page">
      <div className="noise" aria-hidden="true" />
      <nav className="order-topbar" data-testid="order-page-nav">
        <Link to="/" className="brand" style={{ textDecoration: "none" }} data-testid="order-page-brand-link"><span className="brand-mark"><Box size={18} strokeWidth={2.5} /></span><span>Biswas<span className="cyan">3D</span></span></Link>
        <Link to="/" className="map-link" data-testid="order-page-back-link"><ArrowLeft size={16} /> Back to site</Link>
      </nav>
      <OrderSection />
    </div>
  );
}
